<script>
  import { format } from 'svelte-i18n';
  import { Card, CardBody } from '@sveltestrap/sveltestrap';

  import { Capability } from '@client/components/capability';
  import { CustomFields, SelectField, SwitchField } from '@client/components/fields/standalone';
  import { ScrollableSection } from '@client/components/scrollspy';

  import { disabledValue, enabledValue } from '@client/pages/manage/domain-settings';

  import { DEFAULT_SIGNATURE_MODE_OPTIONS } from '@client/enums';

  export let settings = {};
  export let onUpdate = null;
</script>

<div id="google">
  <!-- <ScrollableSection id="google-general">
    <h1 class="mb-3">{$format('label.GENERAL')}</h1>

    <Card>
      <CardBody class="p-4 pt-1">
        <SwitchField
          id="gmailaddin-disableAutoInsertSignatures"
          label={$format('label.AUTOMATIC_SIGNATURES')}
          tooltip={$format('label.TOOLTIP.AUTOMATIC_SIGNATURES')}
          valueOn={$format(enabledValue)}
          valueOff={$format(disabledValue)}
          inverted
          bind:checked={settings.gmailaddin.disableAutoInsertSignatures}
          {onUpdate}
        />

        <SelectField
          id="gmailaddin-defaultSignatureMode"
          label={$format('label.DEFAULT_SIGNATURE_MODE')}
          tooltip={$format('label.TOOLTIP.DEFAULT_SIGNATURE_MODE')}
          selected={DEFAULT_SIGNATURE_MODE_OPTIONS.find(
            ({ value }) => value === settings.gmailaddin.defaultSignatureMode
          )}
          options={DEFAULT_SIGNATURE_MODE_OPTIONS}
          bind:value={settings.gmailaddin.defaultSignatureMode}
          {onUpdate}
        />

        <SwitchField
          id="gmailaddin-enableMultipleSignatures"
          label={$format('label.MULTIPLE_SIGNATURES')}
          tooltip={$format('label.TOOLTIP.MULTIPLE_SIGNATURES')}
          valueOn={$format(enabledValue)}
          valueOff={$format(disabledValue)}
          bind:checked={settings.gmailaddin.enableMultipleSignatures}
          {onUpdate}
        />

        <SwitchField
          id="gmailaddin-disablePlainTextPreview"
          label={$format('label.PLAIN_TEXT_PREVIEW')}
          tooltip={$format('label.TOOLTIP.PLAIN_TEXT_PREVIEW')}
          valueOn={$format(enabledValue)}
          valueOff={$format(disabledValue)}
          inverted
          bind:checked={settings.gmailaddin.disablePlainTextPreview}
          {onUpdate}
        />

        <SwitchField
          id="gmailaddin-disableRemoveDefaultSignature"
          label={$format('label.REMOVE_DEFAULT_SIGNATURE')}
          tooltip={$format('label.TOOLTIP.REMOVE_DEFAULT_SIGNATURE')}
          valueOn={$format(enabledValue)}
          valueOff={$format(disabledValue)}
          inverted
          bind:checked={settings.gmailaddin.disableRemoveDefaultSignature}
          {onUpdate}
        />

        <SwitchField
          id="gmailaddin-userControlledSettings"
          label={$format('label.USER_CONTROLLED_SETTINGS')}
          tooltip={$format('label.TOOLTIP.USER_CONTROLLED_SETTINGS')}
          valueOn={$format(enabledValue)}
          valueOff={$format(disabledValue)}
          bind:checked={settings.gmailaddin.userControlledSettings}
          {onUpdate}
        />

        <SwitchField
          id="gmailaddin-enableVisualPreview"
          label={$format('label.VISUAL_PREVIEW')}
          tooltip={$format('label.TOOLTIP.VISUAL_PREVIEW')}
          valueOn={$format(enabledValue)}
          valueOff={$format(disabledValue)}
          bind:checked={settings.gmailaddin.enableVisualPreview}
          {onUpdate}
        />

        <SwitchField
          id="gmailaddin-clearSignatureIfNoDomain"
          label={$format('label.REMOVE_SIGNATURE_FOR_UNKNOWN_DOMAIN')}
          tooltip={$format('label.TOOLTIP.REMOVE_SIGNATURE_FOR_UNKNOWN_DOMAIN')}
          valueOn={$format(enabledValue)}
          valueOff={$format(disabledValue)}
          bind:checked={settings.gmailaddin.clearSignatureIfNoDomain}
          {onUpdate}
        />

        <SwitchField
          id="gmailaddin-persistSelectionAdminControlled"
          label={$format('label.ALLOW_DEFAULT_OVERRIDE')}
          tooltip={$format('label.TOOLTIP.ALLOW_DEFAULT_OVERRIDE')}
          valueOn={$format(enabledValue)}
          valueOff={$format(disabledValue)}
          bind:checked={settings.gmailaddin.persistSelectionAdminControlled}
          {onUpdate}
        />

        <SwitchField
          id="gmailaddin-resetMultiSelectionOnSend"
          label={$format('label.ALLOW_DEFAULT_OVERRIDE_MUTLTI')}
          tooltip={$format('label.TOOLTIP.ALLOW_DEFAULT_OVERRIDE')}
          valueOn={$format(enabledValue)}
          valueOff={$format(disabledValue)}
          inverted
          bind:checked={settings.gmailaddin.resetMultiSelectionOnSend}
          {onUpdate}
        />

        <SwitchField
          id="gmailaddin-enableInlineImages"
          label={$format('label.INLINE_IMAGES')}
          tooltip={$format('label.TOOLTIP.INLINE_IMAGES')}
          valueOn={$format(enabledValue)}
          valueOff={$format(disabledValue)}
          bind:checked={settings.gmailaddin.enableInlineImages}
          {onUpdate}
        />

        <Capability action="manage" subject="staff">
          <SwitchField
            id="gmailaddin-experimental"
            label="Experimental"
            tooltip="This should only be used by engineering for testing experimental features and functionality."
            valueOn={$format(enabledValue)}
            valueOff={$format(disabledValue)}
            bind:checked={settings.gmailaddin.experimental}
            {onUpdate}
          ></SwitchField>
          <SwitchField
            id="gmailaddin-enableHybridSignatures"
            label={$format('label.HYBRID_SIGNATURES')}
            tooltip={$format('label.TOOLTIP.HYBRID_SIGNATURES')}
            valueOn={$format(enabledValue)}
            valueOff={$format(disabledValue)}
            bind:checked={settings.gmailaddin.enableHybridSignatures}
            {onUpdate}
          ></SwitchField>
        </Capability>
      </CardBody>
    </Card>
  </ScrollableSection> -->

  <ScrollableSection id="google-fields">
    <h1 class="mb-3">{$format('label.USER_AND_SIGNATURE_FIELDS')}</h1>

    <Card>
      <CardBody class="p-4 pt-1">
        <!--
        <SwitchField
          id="gmailaddin-disableDynamicFields"
          label={$format('label.DYNAMIC_FIELDS')}
          tooltip={$format('label.TOOLTIP.DYNAMIC_FIELDS')}
          valueOn={$format(enabledValue)}
          valueOff={$format(disabledValue)}
          inverted
          bind:checked={settings.gmailaddin.disableDynamicFields}
          {onUpdate}
        />

        <SwitchField
          id="gmailaddin-disableFieldEdits"
          label={$format('label.EDITABLE_FIELDS')}
          tooltip={$format('label.TOOLTIP.EDITABLE_FIELDS')}
          inverted
          valueOn={$format(enabledValue)}
          valueOff={$format(disabledValue)}
          bind:checked={settings.gmailaddin.disableFieldEdits}
          {onUpdate}
        />
       -->
        <SwitchField
          id="gmailaddin-signatureFieldsOnly"
          label={$format('label.SIGNATURE_FIELDS_ONLY')}
          tooltip={$format('label.TOOLTIP.SIGNATURE_FIELDS_ONLY')}
          valueOn={$format(enabledValue)}
          valueOff={$format(disabledValue)}
          bind:checked={settings.gmailaddin.signatureFieldsOnly}
          {onUpdate}
        />

        <SwitchField
          id="gmailaddin-enableuihelpers"
          label={$format('label.UI_HELPERS')}
          tooltip={$format('label.TOOLTIP.CUSTOM_COMPOSE_FIELDS')}
          valueOn={$format(enabledValue)}
          valueOff={$format(disabledValue)}
          bind:checked={settings.gmailaddin.enableuihelpers}
          {onUpdate}
        />

        {#if settings.gmailaddin.enableuihelpers}
          <CustomFields
            id="gmailaddin-uihelpers"
            label={$format('label.UI_HELPERS_CONFIGURATION')}
            tooltip={$format('label.TOOLTIP.UI_HELPERS_CONFIGURATION')}
            bind:fields={settings.gmailaddin.uihelpers}
            {onUpdate}
          />
        {/if}
      </CardBody>
    </Card>
  </ScrollableSection>
  <!--
  <ScrollableSection id="google-email-tracking">
    <h1 class="mb-3">{$format('label.EMAIL_TRACKING')}</h1>

    <Card>
      <CardBody class="p-4 pt-1">
        <SwitchField
          id="gmailaddin-enableActivityFeed"
          label={$format('label.ACTIVITY_FEED')}
          tooltip={$format('label.TOOLTIP.ACTIVITY_FEED')}
          valueOn={$format(enabledValue)}
          valueOff={$format(disabledValue)}
          bind:checked={settings.gmailaddin.enableActivityFeed}
          {onUpdate}
        /> -->

  <!-- <SwitchField
          id="gmailaddin-showDoNotTrack"
          label={$format('label.DO_NOT_TRACK')}
          tooltip={$format('label.TOOLTIP.DO_NOT_TRACK')}
          inverted
          valueOn={$format(enabledValue)}
          valueOff={$format(disabledValue)}
          bind:checked={settings.gmailaddin.showDoNotTrack}
          {onUpdate}
        /> -->
  <!-- </CardBody>
    </Card>
  </ScrollableSection> -->

  <!-- <ScrollableSection id="google-shared">
    <h1 class="mb-3">{$format('label.ALIASES_AND_SHARED_INBOXES')}</h1>

    <Card>
      <CardBody class="p-4 pt-1">
        <SwitchField
          id="gmailaddin-disableFromSwitching"
          label={$format('label.FROM_SWITCHING')}
          tooltip={$format('label.TOOLTIP.FROM_SWITCHING')}
          valueOn={$format(enabledValue)}
          valueOff={$format(disabledValue)}
          inverted
          bind:checked={settings.gmailaddin.disableFromSwitching}
          {onUpdate}
        />

        {#if !settings.gmailaddin.disableFromSwitching}
          <SwitchField
            id="gmailaddin-mergeParams"
            label={$format('label.MERGE_USER_FIELDS')}
            tooltip={$format('label.TOOLTIP.MERGE_USER_FIELDS')}
            valueOn={$format(enabledValue)}
            valueOff={$format(disabledValue)}
            bind:checked={settings.gmailaddin.mergeParams}
            {onUpdate}
          />

          {#if settings.gmailaddin.mergeParams}
            <SwitchField
              id="gmailaddin-ignoreblankmergefields"
              label={$format('label.IGNORE_EMPTY_FIELDS')}
              tooltip={$format('label.TOOLTIP.IGNORE_EMPTY_FIELDS')}
              valueOn={$format(enabledValue)}
              valueOff={$format(disabledValue)}
              bind:checked={settings.gmailaddin.ignoreblankmergefields}
              {onUpdate}
            />
          {/if}
        {/if}
      </CardBody>
    </Card>
  </ScrollableSection> -->
</div>

<style lang="scss" src="./google.scss"></style>
